import { render } from "./Default.vue?vue&type=template&id=4aa480c0&scoped=true"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"

import "./Default.vue?vue&type=style&index=0&id=4aa480c0&scoped=true&lang=css"
import "./Default.vue?vue&type=style&index=1&id=4aa480c0&lang=postcss"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa480c0"]])

export default __exports__